import { Component, Input, OnInit } from '@angular/core';
import { ConnectedApp } from '@app/shared/interfaces/lib/connected-app.interface';
import { App, AppsService } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-apps-overview-item',
  templateUrl: './apps-overview-item.component.html',
  styleUrls: ['./apps-overview-item.component.scss'],
})
export class AppsOverviewItemComponent implements OnInit {
  @Input() app: App;

  constructor(private appsService: AppsService) { }

  ngOnInit(): void {
    if (!this.app) {
      throw new Error('[sbnb-apps-overview-item] Must contain a valid App');
    }

    if (this.app.vendorCode) {
      this.appsService.getIntegrationConnectionStatus(this.app.vendorCode).subscribe((app: null | ConnectedApp) => {
        this.app.connected = app !== null;
      });
    }
  }

  onActionClick(): void {
    if (this.app.actionFunction) {
      this.app.actionFunction();
    }
  }
}
